import { Component, OnInit } from '@angular/core';
import { ChangePinStep, SetPinType, ChangePinRequest } from 'src/app/models/account';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

declare var $: any;

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.css']
})
export class ChangePinComponent implements OnInit {
  currentStep: ChangePinStep;

  current_pin: string;
  new_pin: string;
  cnf_pin: string;

  failMessage:string;
  isLoading: boolean = false;

  constructor(private router: Router,
    private authService: AuthenticationService) { }

  get getStep() { return ChangePinStep; }
  get getPinStep() { return SetPinType;}

  ngOnInit() {
    firebase.analytics().logEvent('profil_pin_page');

    this.currentStep = ChangePinStep.SetCurrentPin;
  }
  setCurPin(pin: string){
    this.current_pin = pin;

    const data = this.current_pin;
    this.isLoading = true;
    this.authService.validationPin(data,
      resp => {
        this.isLoading = false;
        if(resp.alert.code == 200){
          this.currentStep = ChangePinStep.SetNewPin;
        }else{
          this.currentStep = ChangePinStep.SetCurrentPin;
          this.failMessage = resp.alert.message;
          $('#fail').modal('show');
        }
      },
      err =>{
        this.currentStep = ChangePinStep.SetCurrentPin;
        this.failMessage = err;
          $('#fail').modal('show');
          console.log('error');
      });
  }
  setNewPin(pin: string){
    this.new_pin = pin;
    this.currentStep = ChangePinStep.SetConfirmPin;
  }
  setCnfPin(pin: string){
    this.cnf_pin = pin;
    if(this.new_pin != this.cnf_pin){
      this.failMessage = 'Pin Konfirmasi tidak sesuai dengan Pin Baru';
      $('#fail').modal('show');
      this.currentStep = ChangePinStep.SetCurrentPin;
    }else{
      let data = new ChangePinRequest();
      data.current_pin = this.current_pin;
      data.new_pin = this.new_pin;
      this.isLoading = true;
      this.authService.changePin(data,
        resp =>{
          this.isLoading = false;
          if(resp.alert.code == 200){
            $('#success').modal('show');
            setTimeout(() =>{
              $('#success').modal('hide');
              this.router.navigate(['/dashboard']);
            }, 2000);
          }else{
            this.currentStep = ChangePinStep.SetCurrentPin;
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err =>{
          this.currentStep = ChangePinStep.SetCurrentPin;
          this.failMessage = err;
            $('#fail').modal('show');
        });
    }
  }

}
